import { createModel } from 'hox';
import useStorageState from '../hooks/useStorageState';
import { OptionDsType, ISelectOption, ITreeSelectData } from '@/types/FmsTypes';
import { defaultMdCmParam, DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants';
import { customerService } from '@/views/base/customer/customerService';
import { supplierService } from '@/views/base/supplier/supplierService';
import { appService } from '@/views/base/app/appService';
import { IMdDictDetail, dictService, CiDictField } from '@/views/base/dict/dictService';
import { forFind } from '@/utils/utils';
import { DictCodeEnmu } from '@/types/FmsDictEnums';
import { warehouseService } from '@/views/base/warehouse/warehouseService';
import { beService } from '@/views/base/be/beService';
import { shopService } from '@/views/base/shop/shopService';
import { isArray } from 'util';
import { accountService, IAcctUnitDetail } from '@/views/account/AccountService';
import { useState, useRef } from 'react';

export function fn(): Promise<ISelectOption[]> {
	let arr: ISelectOption[] = [];
	return Promise.resolve(arr);
}

export type RoleType = {
	id: number;
	name: String;
};
export type UserType = {
	id: string;
	userName: string;
	token: string;
	userPassword: string;
	loginType: 'token' | 'account';
	shopId: string;
	shopName: string;
	shopCode: string;
	currencyName: string;
	createTime?: string;
	createUser?: string;
	deleteFlag?: number;
	orderNumber?: null;
	roleDetails?: [];
	salt?: string;
	staffId?: string;
	updateTime?: string;
	updateUser?: string;
	userAccount?: string;
	userErrorNumber?: number;
	userStatus?: string;
	userCode?: string;
};
export type LoadingType = { loadingVisible: boolean, txt: string };
type GlobalModelType = {
	user: UserType;
	setUser: (e: UserType) => void;
	resetUser: () => void;
	toggleMenu: () => void;
	cm: CmType;
	unit: IAcctUnitDetail | undefined;
	resetCm: () => void;
	initUserState: UserType;

	dictSource: IMdDictDetail[];
	setDictSource: (origin: IMdDictDetail[]) => void;
	dictloadData: () => void;

	appDs: OptionDsType[];
	appLoadDataAll: () => void;

	beDs: OptionDsType[];
	beLoadDataAll: () => void;

	shopDs: OptionDsType[];
	setShopDs: (origin: OptionDsType[]) => void;
	getSelectedDict: (code: DictCodeEnmu) => ISelectOption[];
	getDictNodeName: (code: DictCodeEnmu) => string;

	beShopDs: OptionDsType[];
	setBeShopDs: (
		value: OptionDsType[] | ((previousState?: OptionDsType[] | undefined) => OptionDsType[])
	) => void;

	requestCatchAll: (shopId?: string) => void;

	resourceAuth: string[];
	setResourceAuth: (origin: string[]) => void;

	menuAuth: string[];
	setMenuAuth: (origin: string[]) => void;

	accountTypeDs: OptionDsType[];
	loadAllaccountTypeDs: () => void;

	tradeTypeDs: OptionDsType[];
	loadAlltradeTypeDs: () => void;

	fetchCustomerList: (value: string) => Promise<ISelectOption[]>;
	fetchSupplierList: (value: string) => Promise<ISelectOption[]>;
	fetchWarehouseList: (value: string) => Promise<ISelectOption[]>;
	getTreeSelectOne: (code: DictCodeEnmu, selectable: boolean) => ITreeSelectData[];
	// getAllShopDs: () => {}
	getShopUnit: (shopCode: string) => void;

	mdmBeDs: OptionDsType[];
	mdmBeLoadDataAll: () => void;
	setMdmBeDs: (origin: OptionDsType[]) => void;

	mdmShopDs: OptionDsType[];
	mdmShopLoadDataAll: () => void;
	setMdmShopDs: (origin: OptionDsType[]) => void;

	userBranch: string,
	setUserBranch: (shopCode: string) => void;
	getBranch: (shopCode?: string) => void

	loadingInfo: LoadingType,
	setLoadingInfo: (origin: LoadingType) => void,

	getCiDictAll: () => void;
	getCiDictByDictNumber: (dictNumber?: string) => CiDictField;
	getCiDictByDictCode: (dictCode?: string) => CiDictField;

	isAdmin: boolean,
	setAdmin: (isAdmin: boolean) => void;
};

type labelsType = {
	[proppName: string]: string;
};

type CmType = {
	collapsed: boolean;
};
const initCmState = {
	collapsed: false,
};

function useModel(): GlobalModelType {
	const initUserState: UserType = {
		id: '0',
		userName: '',
		userPassword: '',
		token: '',
		loginType: 'account',
		shopCode: '',
		shopId: '',
		shopName: '',
		currencyName: '',
	};
	const [user, setUser, resetUser] = useStorageState<UserType>('user', initUserState);
	//所有门店
	const [shopDs, setShopDs] = useStorageState<OptionDsType[]>('fms.shopDs', []);
	//所有App系统分支
	const [appDs, setAppDs] = useStorageState<OptionDsType[]>('fms.appDs', []);
	//所有字典
	const [dictSource, setDictSource] = useStorageState<IMdDictDetail[]>('fms.dictSource', []);
	//对应门店的经营实体
	const [beShopDs, setBeShopDs] = useStorageState<OptionDsType[]>('scm.beShopDs', []);
	//所有实体
	const [beDs, setBeDs] = useStorageState<OptionDsType[]>('scm.beDs', []);
	//用户所有菜单权限
	const [menuAuth, setMenuAuth] = useStorageState<string[]>('user.menus', []);
	//用户所有资源权限
	const [resourceAuth, setResourceAuth] = useStorageState<string[]>('user.resource', []);
	const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);
	//账户类型参数account
	const [accountTypeDs, setAccountType, resetAccountType] = useStorageState<OptionDsType[]>(
		'fms.accountType',
		[]
	);
	//单据类型
	const [tradeTypeDs, setTradeType, resetTradeType] = useStorageState<OptionDsType[]>(
		'fms.tradeType',
		[]
	);

	// 内部核算单位
	const [unit, setUnit] = useStorageState<IAcctUnitDetail | undefined>('shop.unit', undefined);

	//所有门店
	const [mdmShopDs, setMdmShopDs] = useStorageState<OptionDsType[]>('mdm.shopDs', []);
	//主数据下所有经营实体
	const [mdmBeDs, setMdmBeDs] = useStorageState<OptionDsType[]>('mdm.beDs', []);
	const [userBranch, setUserBranch] = useStorageState<string>('userBranch', '');
	// 导出loading
	const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: "" });
	//云创数据字典
	const [ciDict, setCiDict] = useState<CiDictField[]>([]);
	const ciDictRef = useRef(ciDict);
	ciDictRef.current = ciDict;
	//是否财务管理元
	const [isAdmin, setAdmin] = useStorageState<boolean>('isAdmin', false);

	// 获取门店对应的内部核算单位
	const getShopUnit = async (shopCode: string) => {
		const { retData } = await accountService.allotFindOne(shopCode);
		setUnit(retData);
	};

	const toggleMenu = () => {
		setCm({
			...cm,
			collapsed: !cm.collapsed,
		});
	};

	//初始应用分支缓存
	const appLoadDataAll = async () => {
		let { retData } = await appService.find({});
		let appOptios = retData.map((item) => ({
			label: item.name ?? '',
			value: item.code ?? '',
		}));
		setAppDs(appOptios);
	};

	//初始所有实体
	const beLoadDataAll = async () => {
		let { retData } = await beService.find({});
		let beOptios = retData.map((item) => ({
			label: item.name ?? '',
			value: (item.key as string) ?? '',
			code: item.code ?? '',
		}));
		setBeDs(beOptios);
	};

	//初始所有用户类型
	const loadAllaccountTypeDs = async () => {
		const ds = await dictService.dictItemDs('account-type');
		setAccountType(ds);
	};

	//初始所有单据类型
	const loadAlltradeTypeDs = async () => {
		const ds = await dictService.dictItemDs('trade-type');
		setTradeType(ds);
	};

	//初始化所有字典
	const dictloadData = async () => {
		let { retData } = await dictService.allTree({});
		setDictSource(retData);
	};

	//所有缓存加载
	const requestCatchAll = () => {
		appLoadDataAll();
		dictloadData();
		beLoadDataAll();
	};

	//初始页数
	const defaultPage = { pageSize: 20, pageNum: DEFAULT_FIRST_PAGE_NUM };
	//实时查询客户接口
	const fetchCustomerList = async (value: string) => {
		if (!value) return await fn();
		let data = {
			name: value,
			page: defaultPage,
		};
		return customerService.page(data).then((res) => {
			const {
				retData: { records },
			} = res;
			return records
				? records.map((el) => ({
					key: el.key ?? '',
					id: el.key ?? '',
					label: el.name ?? '',
					value: el.code ?? '',
				}))
				: [];
		});
	};

	//实时查询供应商接口
	const fetchSupplierList = async (value: string) => {
		if (!value) return await fn();
		let data = {
			name: value,
			page: defaultPage,
		};
		return supplierService.page(data).then((res) => {
			const {
				retData: { records },
			} = res;
			return records
				? records.map((el) => ({
					label: el.name ?? '',
					value: el.code ?? '',
				}))
				: [];
		});
	};

	//实时查询供应商接口
	const fetchWarehouseList = async (value: string) => {
		if (!value) return await fn();
		let data = {
			name: value,
			page: defaultPage,
		};
		return warehouseService.page(data).then((res) => {
			const {
				retData: { records },
			} = res;
			return records
				? records.map((el) => ({
					label: el.name ?? '',
					value: el.code ?? '',
				}))
				: [];
		});
	};

	//根据pcode返回 select框的options 格式；
	const getSelectedDict = (code: DictCodeEnmu): ISelectOption[] => {
		let findTree: IMdDictDetail | undefined = forFind(dictSource, code, 'code');
		return findTree
			? findTree.children
				?.filter((item) => item.enable)
				.map((item) => ({
					label: item.name ?? '',
					value: item.code ?? '',
					type: item.value ?? '',
				})) ?? []
			: [];
	};

	//根据code 返回对应的node节点名称
	const getDictNodeName = (code: string): string => {
		let findNode: IMdDictDetail | undefined = forFind(dictSource, code, 'code');
		return findNode ? findNode?.['name'] ?? '' : '';
	};

	const mapTree = (org: IMdDictDetail, selectable: boolean): ITreeSelectData => {
		const haveChildren = Array.isArray(org.children) && org.children.length > 0;
		return {
			title: org.name ?? '',
			value: org.code ?? '',
			selectable: selectable ? true : haveChildren ? false : true,
			//判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
			children: haveChildren ? org.children?.map((i) => mapTree(i, selectable)) ?? [] : [],
		};
	};
	/**
	 *
	 * @param code 根据code 返回treeSelect 数据格式
	 * @param selectable 有子节点的父节点不能选中  (默认只能选中子节点)
	 */
	const getTreeSelectOne = (code: DictCodeEnmu, selectable: boolean = false): ITreeSelectData[] => {
		let findTree: IMdDictDetail | undefined = forFind(dictSource, code, 'code');
		let resultTree: ITreeSelectData[] = findTree ? mapTree(findTree, selectable).children : [];
		return resultTree;
	};

	// const getAllShopDs = async() => {
	//     let { retData } = await shopService.find({});
	//     if (isArray(retData)) {
	//             setShopDs(retData.map(item => ({
	//                     id: item.id,
	//                     label: item.name ?? "",
	//                     value: item.code ?? ""
	//             })));
	//     } else {
	//             setShopDs([]);
	//     }
	// }

	//初始主数据所有经营实体缓存
	const mdmBeLoadDataAll = async () => {
		const searchParams = {
			// ...defaultMdCmParam,
			// branch: "",
			page: {
				pageSize: 999999,
				pageNum: 1,
			},
		};
		let { retData } = await beService.page(searchParams);
		const { records } = retData;
		setMdmBeDs(
			records.map((item) => ({
				id: item.key as string,
				label: item.name ?? '',
				value: item.code ?? '',
			}))
		);
	};
	// 主数据门店缓存
	const mdmShopLoadDataAll = async () => {
		let data = { page: { pageSize: 9999, pageNum: 1 } };
		const {
			retData: { records },
		} = await shopService.page(data);
		const shopOptions = records.map((item) => ({
			key: item.id,
			id: item.id,
			label: item.name,
			value: item.code,
			branch: item.branch,
		}));
		setMdmShopDs(shopOptions);
	};

	// 用户系统分支缓存
	const getBranch = async (code?: string) => {
		let params = {
			code: code ?? user.shopCode,
			sourceApp: 'fms',
		};
		let { retData } = await shopService.one(params);
		let { branch } = retData;
		setUserBranch(branch);
	};

	// 云创字典
	const getCiDictAll = async () => {
		let { retData } = await dictService.getCiDictAll();
		setCiDict(retData);
	};

	const getCiDictByDictNumber = (dictNumber?: string): CiDictField => {
		let ret = forFind(ciDictRef.current, dictNumber ?? "", 'dictNumber')
		return ret;
	};

	const getCiDictByDictCode = (dictCode?: string): CiDictField => {
		let ret = forFind(ciDictRef.current, dictCode ?? "", 'dictCode')
		return ret;
	};

	return {
		user,
		setUser,
		resetUser,
		toggleMenu,
		cm,
		unit,
		resetCm,
		initUserState,
		shopDs,
		setShopDs,
		beDs,
		beLoadDataAll,
		dictSource,
		setDictSource,
		dictloadData,
		accountTypeDs,
		getShopUnit,
		appDs,
		appLoadDataAll,
		requestCatchAll,
		resourceAuth,
		setResourceAuth,
		tradeTypeDs,
		menuAuth,
		setMenuAuth,
		beShopDs,
		setBeShopDs,
		fetchCustomerList,
		fetchSupplierList,
		fetchWarehouseList,
		getSelectedDict,
		getDictNodeName,
		getTreeSelectOne,
		loadAllaccountTypeDs,
		// getAllShopDs,
		mdmBeLoadDataAll,
		mdmBeDs,
		setMdmBeDs,
		mdmShopDs,
		setMdmShopDs,
		mdmShopLoadDataAll,
		loadAlltradeTypeDs,
		userBranch,
		setUserBranch,
		getBranch,
		loadingInfo,
		setLoadingInfo,
		getCiDictAll,
		getCiDictByDictNumber,
		getCiDictByDictCode,
		isAdmin, setAdmin
	};
}

export const useGlobalModel = createModel(useModel);
export default useGlobalModel;
